import constants from "../config/constants";
import { postRequest } from "../libs/AxiosService.util";

export async function serviceDietitianDashboardPatientData(params) {
    return await postRequest("dashboard/client/dietitian/patients-data", params);
}


export async function serviceDietitianDashboardTimeSpentData(params) {
    return await postRequest("dashboard/client/dietitian/time-spent-data", params);
}


export async function serviceDietitianDashboardPatientTrend(params) {
    return await postRequest("dashboard/client/dietitian/patients-trend", params);
}


export async function serviceDietitianDashboardConsultationRecord(params) {
    return await postRequest("dashboard/client/dietitian/consultation-record", params);
}

export async function serviceDietitianDashboardUpcomingSessions(params) {
    return await postRequest("dashboard/client/dietitian/upcoming-sessions", params);
}

export async function serviceDietitianDashboardConsultationHistory(params) {
    return await postRequest("dashboard/client/dietitian/consultation-history", params);
}

export async function serviceDietitianDashboardPatientDetail(params) {
    return await postRequest("dashboard/client/dietitian/patient-details", params);
}



export async function serviceDietitianTrendChartExport(params, token) {
    return await fetch(constants.DEFAULT_APP_URL + "dashboard/client/dietitian/patients-trend/export", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify({
            ...params
        }),
    });
}

export async function serviceDietitianConsultationRecordExport(params, token) {
    return await fetch(constants.DEFAULT_APP_URL + "dashboard/client/dietitian/consultation-record/export", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify({
            ...params
        }),
    });
}

export async function serviceDietitianConsultationHistroyExport(params, token) {
    return await fetch(constants.DEFAULT_APP_URL + "dashboard/client/dietitian/consultation-history/export", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify({
            ...params
        }),
    });
}
